<template>
    <header class="header" :class="`header--${name}`">
        <router-link to="/"><img src="@/assets/logo_light.svg" :alt="$logo"/></router-link>

        <ul class="demo" v-bind:style="{ gridTemplateColumns: 'repeat(' + routes.length + ', 1fr) 60px' }">
            <router-link v-for="(route, index) in routes" :key="`router-link-${index}`" tag="li" :to="{ name: route.name }" active-class="active">
                <a href="#">{{ route.label }}</a>
            </router-link>

            <AccountMenu
                :routes="profileRoutes"
            />
        </ul>
    </header>
</template>
<script>
import AccountMenu from '@/components/AccountMenu/AccountMenu';

export default {
    name: 'Header',

    props: {
        name: {
            type: String,
            required: true,
        },

        routes: {
            type: Array,
            required: true,
        },

        profileRoutes: {
            type: Array,
            required: false,
        },
    },

    components: {
        AccountMenu,
    },
};
</script>
<style lang="scss">
.header {
    height: 100px;
    background-color: $primary;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 32px;

    img {
        max-width: 300px;
        max-height: 60px;
    }

    li.header--account {
        width: 60px;
        height: 60px;
        background-color: $yellow;
        border-radius: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: center;
        cursor: pointer;
        position: relative;
        padding: 0;

        > ul {
            top: 70px;
            right: 0px;
            position: absolute;
            margin: 0;
            margin-block-start: 0;
            margin-block-end: 0;
            padding: 0;
            list-style: none;
            width: 200px;
            z-index: 1;

            li {
                background-color: #A0B3C4;
                text-align: center;
                padding-top: 8px;
                padding-bottom: 8px;
                border-bottom: 1px solid white;

                &:first-child {
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                }

                &:last-child {
                    border-bottom-left-radius: 4px;
                    border-bottom-right-radius: 4px;
                    border-bottom: unset;
                }

                a {
                    color: black;
                    text-decoration: none;
                    font-size: 14px;
                }
            }
        }

        i {
            font-size: 20px;
        }
    }

    > ul {
        margin: 0;
        margin-block-start: 0;
        margin-block-end: 0;
        padding: 0;
        list-style: none;
        display: grid;
        grid-gap: 16px;
        text-align: center;

        > li {
            padding: 32px;
            padding-top: 34px;

            > a {
                color: $white;
                text-decoration: none;
                font-size: 20px;
                padding: 32px;
                text-align: center;
            }

            &.active {
                border-bottom: 10px solid $blue;

                a {
                    font-weight: 800;
                }
            }
        }
    }
}
</style>
